import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PaginatedResultModel, ShortModel } from '@data-layer/models/common';
import { PaymentMethodManagementModel } from '@data-layer/models/payments';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsManagementRepository {
  constructor(private apiService: ApiService) {}

  public getPaymentMethods(isShowLoader?: boolean): Observable<PaginatedResultModel<PaymentMethodManagementModel>> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/payment-methods`, null, { isShowLoader });
  }

  public getPaymentMethod(id: number, isShowLoader?: boolean): Observable<PaymentMethodManagementModel> {
    return this.apiService.get<PaymentMethodManagementModel>(`${environment.url.prefixCustoms}v2/management/payment-methods/${id}`, null, {
      isShowLoader,
    });
  }

  public getPaymentMethodCodes(isShowLoader?: boolean): Observable<ShortModel[]> {
    return this.apiService.get<ShortModel[]>(`${environment.url.prefixCustoms}v2/management/payment-methods/codes`, null, {
      isShowLoader,
    });
  }

  public getPaymentMethodCode(id: number, isShowLoader?: boolean): Observable<ShortModel> {
    return this.apiService.get<ShortModel>(`${environment.url.prefixCustoms}v2/management/payment-methods/codes/${id}`, null, {
      isShowLoader,
    });
  }

  public createPaymentMethod(data: PaymentMethodManagementModel, isShowLoader?: boolean): Observable<PaymentMethodManagementModel> {
    return this.apiService.post<PaymentMethodManagementModel>(`${environment.url.prefixCustoms}v2/management/payment-methods`, data, null, {
      isShowLoader,
    });
  }

  public createPaymentMethodCode(name: string, isShowLoader?: boolean): Observable<PaymentMethodManagementModel> {
    return this.apiService.post<PaymentMethodManagementModel>(
      `${environment.url.prefixCustoms}v2/management/payment-methods/codes/${name}`,
      null,
      null,
      {
        isShowLoader,
      },
    );
  }

  public updatePaymentMethod(data: PaymentMethodManagementModel, isShowLoader?: boolean): Observable<PaymentMethodManagementModel> {
    return this.apiService.put<PaymentMethodManagementModel>(
      `${environment.url.prefixCustoms}v2/management/payment-methods/${data.id}`,
      data,
      null,
      {
        isShowLoader,
      },
    );
  }

  public updatePaymentMethodCode(id: number, name: string, isShowLoader?: boolean): Observable<PaymentMethodManagementModel> {
    return this.apiService.put<PaymentMethodManagementModel>(
      `${environment.url.prefixCustoms}v2/management/payment-methods/codes/${id}/${name}`,
      null,
      null,
      {
        isShowLoader,
      },
    );
  }

  public deletePaymentMethod(id: number, isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete<never>(`${environment.url.prefixCustoms}v2/management/payment-methods/${id}`, null, {
      isShowLoader,
    });
  }
}
